/**
 * Every live view uses the same fixed set of media slots, in this order. The parent's browser offers
 * them; the child's device answers and fills the first four. Turning a camera or the parent's
 * microphone on or off swaps the track in its slot, so the call never has to renegotiate.
 */
export const SLOTS = [
  { name: 'screen', kind: 'video', from: 'child' },
  { name: 'camera', kind: 'video', from: 'child' },
  { name: 'mic', kind: 'audio', from: 'child' },
  { name: 'audio', kind: 'audio', from: 'child' },
  { name: 'talk', kind: 'audio', from: 'parent' },
  { name: 'talkVideo', kind: 'video', from: 'parent' },
] as const;

export type SlotName = (typeof SLOTS)[number]['name'];

export interface SignalData {
  description?: RTCSessionDescriptionInit;
  candidate?: RTCIceCandidateInit | null;
}
